import { Modal } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { getAllData, getDataById } from '../apis/generalApis'
import FeaturedServiceCard from '../components/Cards/FeaturedServiceCard'
import '../styles/Modal.scss'
import CreateServiceModal from './CreateServiceModal'
import ServiceTypesModal from './ServiceTypesModal'
import SetSkillRateModal from './SetSkillRateModal'

// const style = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   maxHeight: '90vh',
//   overflow: 'auto',
//   transform: 'translate(-50%, -50%)',
//   bgcolor: 'background.paper',
//   border: 'none',
//   boxShadow: '0px 5px 20px #00000040',
//   p: 4,
//   outline: 'none',
//   borderRadius: '16px',
//   textAlign: 'center',
// }

const AddSkillsModal = ({
  handleAddSkillsModal,
  toggleAddSkillsModal,
  stylistSkills,
  selectedClient,
}) => {
  const [serviceTypesModalOpen, setServiceTypesModalOpen] = useState(false)
  const [services, setServices] = useState([])
  const [serviceTypeModal, setServiceTypeModal] = useState(false)
  const [createServiceModal, setCreateServiceModal] = useState(false)
  const [selectedService, setSelectedService] = useState({})

  const handleServiceTypesModal = () => {
    if (toggleAddSkillsModal) {
      handleAddSkillsModal(false)
    }
    setServiceTypeModal(!serviceTypeModal)
  }

  useEffect(() => {
    getServices({})
  }, [])

  const handleCreateServiceModal = () => {
    handleAddSkillsModal(false)
    setCreateServiceModal()
  }

  const getServices = async (body) => {
    let result = await getDataById('show-services', body)
    if (result?.success === true && result?.data != null) {
      setServices(result?.data)
    }
  }

  const handleServiceTypesModalOpen = () => {
    if (toggleAddSkillsModal) {
      handleAddSkillsModal(false)
    }
    setServiceTypesModalOpen(!serviceTypesModalOpen)
  }

  return (
    <div>
      <Modal
        open={toggleAddSkillsModal}
        onClose={() => handleAddSkillsModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-box">
          <div className="m-0 text-center">
            {stylistSkills && (
              <h1 className="fs-20 m-0 py-1 text-black font-weight-bold">
                Featured Services
              </h1>
            )}
            <div className="row mt-2 g-3 flex-nowrap overflow-auto pb-3">
              {stylistSkills?.map(
                (service, index) =>
                  service?.service?.is_feature === true && (
                    <div
                      className="col-12 col-sm-6 col-md-6 col-lg-3 pointer"
                      key={service?.id}
                      onClick={() => {
                        handleServiceTypesModal()
                        setSelectedService(service)
                      }}
                    >
                      <FeaturedServiceCard
                        service={service}
                        className="client-dashboard"
                      />
                    </div>
                  ),
              )}
            </div>
            {stylistSkills && (
              <h1 className="fs-20 m-0 py-1 text-black font-weight-bold">
                Services
              </h1>
            )}
            {/* <h1 className="fs-20 m-0 py-1 text-black font-weight-bold mt-3">
              Services
            </h1> */}
            <div className="row mt-2 g-3">
              {stylistSkills?.map(
                (service, index) =>
                  service?.service?.is_feature === false && (
                    <div
                      className="col-12 col-sm-6 col-md-6 col-lg-3 pointer"
                      key={service?.id}
                      onClick={() => {
                        handleServiceTypesModal()
                        setSelectedService(service)
                      }}
                    >
                      <FeaturedServiceCard
                        service={service}
                        className="client-dashboard"
                      />
                    </div>
                  ),
              )}
            </div>
          </div>
        </Box>
      </Modal>
      {/* <CreateServiceModal
        handleCreateServiceModal={handleCreateServiceModal}
        createServiceModal={createServiceModal}
      /> */}
      <ServiceTypesModal
        handleServiceTypesModal={handleServiceTypesModal}
        modalOpen={serviceTypeModal}
        screenName={'provider-search-screen'}
        service={{ ...selectedService, client: selectedClient }}
      />
    </div>
  )
}

export default AddSkillsModal
